<div class="card">
    <p-fieldset class="title-legend" legend="Informações da receita">
        <div class="formgrid grid m-0">
            <div class="field col-3 md:col-4 lg:col-2">
                <label for="">OS</label>
                <input class="w-full p-inputtext-sm" pInputText maxlength="100" [(ngModel)]="dadosForm.numeroOS" />
            </div>

            <div class="field col-9 md:col-8 lg:col-7">
                <label for="">Paciente</label>
                <input class="w-full p-inputtext-sm" pInputText maxlength="100" [(ngModel)]="dadosForm.paciente" />
                
            </div>

            <div class="field col-12 md:col-6 lg:col-3">
                <label>Data Receita</label>
                <p-calendar [(ngModel)]="dadosForm.DtReceita" dateFormat="dd/mm/yy" [showIcon]="true" [maxDate]="maxDate" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm text-sm p-datepicker-sm'"></p-calendar>
                
            </div>
            
        </div>

        <h4 [style]="{ 'margin': '0 0 1.5rem .75rem' }">Selecione o olho para informar os dados da receita</h4>

        <div class="card flex">
            <div class="flex flex-wrap gap-1 md:gap-3 xl:gap-3 text-sm option-olho">
                <div class="flex align-items-center">
                    <p-radioButton name="olho" value="olho_direito" [(ngModel)]="dadosForm.opcaoOlhoSelecionado" inputId="olho_direito" (click)="verificarProduto('D')"></p-radioButton>
                    <label for="olho_direito" class="ml-2">Olho direito</label>
                </div>

                <div class="flex align-items-center">
                    <p-radioButton name="olho" value="olho_esquerdo" [(ngModel)]="dadosForm.opcaoOlhoSelecionado" inputId="olho_esquerdo" (click)="verificarProduto('E')"></p-radioButton>
                    <label for="olho_esquerdo" class="ml-2">Olho esquerdo</label>
                </div>

                <div class="flex align-items-center">
                    <p-radioButton name="olho" value="ambos" [(ngModel)]="dadosForm.opcaoOlhoSelecionado" inputId="ambos" (click)="verificarProduto()"></p-radioButton>
                    <label for="ambos" class="ml-2">Ambos</label>
                </div>
            </div>
        </div>

        <app-novo-pedido-olho [titulo]="'Olho direito'"  [olho]="dadosForm.olhoDireito"  [codLoja]="codLoja" [codCliente]="codCliente" *ngIf="dadosForm.opcaoOlhoSelecionado === 'olho_direito' || dadosForm.opcaoOlhoSelecionado === 'ambos'"  (DNPLongeChange)="DnpLongeDireitoChange($event)"  (ProdutoChange)="changeProduto($event, 'D')" (QuantidadeChange)="changeQuantidade($event, 'D')" class="cp-olho-esquerdo"></app-novo-pedido-olho>

        <app-novo-pedido-olho [titulo]="'Olho esquerdo'" [olho]="dadosForm.olhoEsquerdo" [codLoja]="codLoja" [codCliente]="codCliente" *ngIf="dadosForm.opcaoOlhoSelecionado === 'olho_esquerdo' || dadosForm.opcaoOlhoSelecionado === 'ambos'" (DNPLongeChange)="DnpLongeEsquerdoChange($event)" (ProdutoChange)="changeProduto($event, 'E')" (QuantidadeChange)="changeQuantidade($event, 'E')"></app-novo-pedido-olho>

    </p-fieldset>
    
    <p-fieldset class="title-legend" legend="Dados da armação">
        <div class="formgrid grid m-0">
            <div class="field col-12">
                <label>Tipo de montagem</label>
                <p-dropdown inputId="tipo_montagem" class="p-inputtext-sm" [options]="tiposMontagem" [(ngModel)]="dadosForm.armacao.tipoMontagem" placeholder="Selecione o tipo de montagem" optionLabel="nome" [showClear]="true" [style]="{'width':'100%'}" [styleClass]="'p-inputtext-sm'"></p-dropdown>
            </div>
        </div>

        <div class="p-fluid formgrid m-0 grid">
            <div class="flex-auto field col-6 md:col-4 lg:col-1">
                <label>Ponte</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoPonte" (onInput)="armacaoChange($event)"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-1">
                <label>Aro</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoAro" (onInput)="armacaoChange($event)"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Altura vertical</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoAltVertical" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Diagonal maior</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoDiagMaior" (onInput)="armacaoChange($event)"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Diâmetro apurado</label>
                <p-inputNumber class="p-inputtext-sm" [(ngModel)]="dadosForm.armacao.armacaoDiamApurado" mode="decimal" [disabled]="true"> </p-inputNumber>
            </div>

            <div class="flex-auto field col-6 md:col-4 lg:col-2">
                <label>Distância pupilar</label>
                <input type="text" class="inputP" (input)="formatarInput($event.target)"[(ngModel)]="dadosForm.armacao.armacaoDistPupilar" [maxlength]="maxlength"/>
            </div>
        </div>
    </p-fieldset>

    <app-novo-pedido-outros-servicos [legend]="'Outros Itens'" [codLoja]="codLoja" [codCliente]="codCliente" [servicosAdicionados]="servicosAdicionados"></app-novo-pedido-outros-servicos>

</div>